import * as React from "react";
import { COutlookTask } from "../../Entity/OutlookTaskObj";
import MIPADatePicker from "../Common/datepicker";
import "./Task.scss";
import MIPAChoiceAction from "../Common/ChoiceAction";
import {IContextualMenuItem} from "office-ui-fabric-react/lib/ContextualMenu";
import { DateHelper } from "../../Helpers/DateHelper";
export interface IProps {
  data: COutlookTask;
  UpdateToDoItem;
  Phrases;
  usertimezone;
}
export default class OutlookTask extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }
  public render() {
    let end = this.props.data.dueDateTime.dateTime;
    let webpartbody =
      this.props.data.col < 0
        ? ["webpartbody", "overdue"].join(" ")
        : "webpartbody";
    let rowcss = "ms-Grid-row miparow";
    let statusdisplay=this.getstatusdisplay(this.props.data.status);
    //let editurl='https://outlook.office.com/owa/?viewmodel=TaskReadingPaneViewModelPopOutFactory&ispopout=1&path=/tasks&ItemID='+encodeURIComponent(this.props.data.id);
    return (
      <div className="webpart">
        <div className="webpartTitle">
          <i className="ms-Icon ms-Icon--ToDoLogoInverse" />
          {this.props.Phrases.title}
        </div>
        <div className={webpartbody}>
          <div className="ms-Grid">
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div className={["subject", "ellips"].join(" ")}>
                  {this.props.data.subject}
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div>
                  <label className="label">
                    {this.props.Phrases.start} :{" "}
                  </label>
                  {this.props.data.startDateTime != null ? (
                    DateHelper.GetDisplayDatestring(this.props.data.startDateTime.dateTime,true)
                   /*  <Moment format="DD MMM YY">
                      {this.props.data.startDateTime.dateTime}
                    </Moment> */
                  ) : null}
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div
                  className="dateleft"
                  title={this.props.Phrases.setduedate}
                >
                  <MIPADatePicker
                    datevalue={end}
                    ChangeDate={date => {
                      this.UpdateTODO("dueDateTime", date);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div>
                  <label className="label">
                    {this.props.Phrases.status} :{" "}
                  </label>{" "}
                  <MIPAChoiceAction
                    contextbuttoncss='contextbutton'
                    items={this.PrepareStatustItems()}
                  >
                    <div className={['statusbox', 'ellips'].join(" ")}>
                      {statusdisplay}
                    </div>
                  </MIPAChoiceAction>
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div>
                  <label className="label">
                    {this.props.Phrases.importance} :{" "}
                  </label>{" "}
                  <MIPAChoiceAction
                     contextbuttoncss='contextbutton'
                    items={this.PrepareImportantItems()}
                  >
                    <div className={['statusbox', 'ellips'].join(" ")}>
                    {this.props.data.importance}
                    </div>
                  </MIPAChoiceAction>
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div>
                  <label className="label">
                    {this.props.Phrases.sensitivity} :{" "}
                  </label>{" "}
                  <MIPAChoiceAction
                     contextbuttoncss='contextbutton'
                    items={this.PrepareSensivityItem()}
                  >
                    <div className={['statusbox', 'ellips'].join(" ")}>
                    {this.props.data.sensitivity}
                    </div>
                  </MIPAChoiceAction>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="webpartfooter">
          <Checkbox
            className="checkbox"
            label={this.props.Phrases.markcomplete}
            onChange={() => {
              this.UpdateTODO("completedDateTime", null);
            }}
          />
        </div> */}
      </div>
    );
  }
  public UpdateTODO = (property, newvalue) => {
    let task = {};
    if (property == "completedDateTime") {
      task = {
        completedDateTime: {
          dateTime: new Date().toISOString(),
          //timeZone: Helper.getTimeZoneId()
          timeZone: this.props.usertimezone
        },
        status: "completed"
      };
    } else if (property == "status") {
      task = {
        status: newvalue
      };
    } else if (property == "dueDateTime") {
      task = {
        dueDateTime: {
          dateTime: newvalue,
          //timeZone: Helper.getTimeZoneId(),
          timeZone: this.props.usertimezone
        }
      };
    }
    else{
        task[property]=newvalue;
    }
    this.props.UpdateToDoItem(this.props.data.id, task, this.props.data.col);
  };
  public getstatusdisplay=(status)=>{
    let displayname='';
    switch(status){
        case 'notStarted':
          displayname= 'Not started';
          break;
        case 'inProgress':
          displayname= 'In progress';
          break;
        case 'completed':
          displayname= 'Completed';
          break;
        case 'waitingOnOthers':
          displayname= 'Waiting on others';
          break;
        case 'deferred':
          displayname= 'Deferred';
          break;
    }
    return displayname;
}
public PrepareImportantItems(): IContextualMenuItem[]{
    let menus = [];
    let keyIndex = 0;    
    ['low', 'normal', 'high'].forEach(element => {
      let menu = {
        key: "todoimportance_" + element + "_" + keyIndex,
        name: element,
        iconProps: {
          className:
            this.props.data.importance == element
              ? "ms-Icon ms-Icon--RadioBtnOn"
              : "ms-Icon ms-Icon--RadioBtnOff"
        },
        onClick: () => {
          if (this.props.data.importance != element) {           
            this.UpdateTODO('importance', element);
          }
          // this.UpdateSSOValue(this.props.data.ID,element.id,'IGlobeCRM_SSO_Pipeline','Choice',this.props.data.SSOColmn);
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }
  public PrepareSensivityItem(): IContextualMenuItem[]{
    let menus = [];
    let keyIndex = 0;
    
    ['normal', 'personal', 'private', 'confidential'].forEach(element => {
      let menu = {
        key: "todoimportance_" + element + "_" + keyIndex,
        name: element,
        iconProps: {
          className:
            this.props.data.sensitivity == element
              ? "ms-Icon ms-Icon--RadioBtnOn"
              : "ms-Icon ms-Icon--RadioBtnOff"
        },
        onClick: () => {
          if (this.props.data.importance != element) {           
            this.UpdateTODO('sensitivity', element);
          }
          // this.UpdateSSOValue(this.props.data.ID,element.id,'IGlobeCRM_SSO_Pipeline','Choice',this.props.data.SSOColmn);
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }
  public PrepareStatustItems(): IContextualMenuItem[] {
    let menus = [];
    let keyIndex = 0;
    let statuslist = [
      {
        name: 'notStarted',
        display: 'Not started'
      },
      {
        name: 'inProgress',
        display: 'In progress'
      },
      {
        name: 'completed',
        display: 'Completed'
      },
      {
        name: 'waitingOnOthers',
        display: 'Waiting on others'
      },
      {
        name: 'deferred',
        display: 'Deferred'
      }
    ];
    statuslist.forEach(element => {
      let menu = {
        key: "todostatus_" + element.name + "_" + keyIndex,
        name: element.display,
        iconProps: {
          className:
            this.props.data.status == element.name
              ? "ms-Icon ms-Icon--RadioBtnOn"
              : "ms-Icon ms-Icon--RadioBtnOff"
        },
        onClick: () => {
          if (this.props.data.status != element.name) {
            let propname = "completedDateTime";
            if (element.name != "completed") {
              propname = "status";
            }
            this.UpdateTODO(propname, element.name);
          }
          // this.UpdateSSOValue(this.props.data.ID,element.id,'IGlobeCRM_SSO_Pipeline','Choice',this.props.data.SSOColmn);
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }
  
}
